// extracted by mini-css-extract-plugin
export var arrow = "_3c-6";
export var changeItem = "_3c-3";
export var changesHeader = "_3c-1";
export var changesList = "_3c-2";
export var container = "_3c-0";
export var pathLabel = "_3c-4";
export var value = "_3c-7";
export var valuesContainer = "_3c-5";